export const CATALOGO_UNIDADES = {
  Unidades: [
    {
      id: 1,
      activo: true,
      descripcion: 'KILOGRAMO',
      abreviatura: 'KG',
      clave_sat: ''
    },
    {
      id: 2,
      activo: true,
      descripcion: 'LITRO',
      abreviatura: 'LT',
      clave_sat: ''
    },
    {
      id: 3,
      activo: true,
      descripcion: 'PIEZA',
      abreviatura: 'PZA',
      clave_sat: ''
    },
    {
      id: 4,
      activo: true,
      descripcion: 'MILILITRO',
      abreviatura: 'ML',
      clave_sat: ''
    },
    {
      id: 5,
      activo: true,
      descripcion: 'CAJA',
      abreviatura: 'CAJ',
      clave_sat: ''
    },
    {
      id: 6,
      activo: true,
      descripcion: 'TABLETA',
      abreviatura: 'TAB',
      clave_sat: ''
    },
    {
      id: 7,
      activo: true,
      descripcion: 'BOLSA',
      abreviatura: 'BSA',
      clave_sat: ''
    },
    {
      id: 8,
      activo: true,
      descripcion: 'BULTO',
      abreviatura: 'BTO',
      clave_sat: ''
    },
    {
      id: 9,
      activo: true,
      descripcion: 'AMPOLLETA',
      abreviatura: 'AMP',
      clave_sat: ''
    },
    {
      id: 10,
      activo: true,
      descripcion: 'FRASCO',
      abreviatura: 'FCO',
      clave_sat: ''
    },
    {
      id: 11,
      activo: true,
      descripcion: 'PAQUETE',
      abreviatura: 'PAQ',
      clave_sat: ''
    },
    {
      id: 12,
      activo: true,
      descripcion: 'GRAMO',
      abreviatura: 'GR',
      clave_sat: ''
    },
    {
      id: 13,
      activo: true,
      descripcion: 'LATA',
      abreviatura: 'LTA',
      clave_sat: ''
    },
    {
      id: 14,
      activo: true,
      descripcion: 'UNIDAD',
      abreviatura: 'UND',
      clave_sat: ''
    },
    {
      id: 15,
      activo: true,
      descripcion: 'COMPRIMIDO',
      abreviatura: 'COMP',
      clave_sat: ''
    },
    {
      id: 16,
      activo: true,
      descripcion: 'TUBO',
      abreviatura: 'TUB',
      clave_sat: ''
    },
    {
      id: 17,
      activo: true,
      descripcion: 'DOSIS',
      abreviatura: 'DOSI',
      clave_sat: ''
    },
    {
      id: 18,
      activo: true,
      descripcion: 'CÁPSULAS',
      abreviatura: 'CAPS',
      clave_sat: ''
    },
    {
      id: 19,
      activo: true,
      descripcion: 'SOBRE',
      abreviatura: 'SOB',
      clave_sat: ''
    },
    {
      id: 20,
      activo: true,
      descripcion: 'UNIDAD DE SERVICIO',
      abreviatura: 'SERV',
      clave_sat: ''
    },
  ]
}

export const UNIDAD_BASE_OBJ = {
  id: null,
  activo: true,
  descripcion: '',
  abreviatura:'',
  clave_sat:'',
  fecha_alta:null,
}


// WEBPACK FOOTER //
// ./src/constantes/catalogos/unidades.js